<template>
	<div>
		<div>
			<Header />
			<main>
				<Nav />
				<div>
					<slot></slot>
				</div>
			</main>
			<Footer />
		</div>
	</div>
</template>

<script>

	import Header from "@/components/common/Header.vue";
	import Nav from "@/components/common/Nav.vue";
	import Footer from "@/components/common/Footer.vue";

	export default {
		name: "LayoutMain",
		components:
		{
			Header,
			Nav,
			Footer
		}
	};
</script>